import { ControllerInterface } from "csi/action/Controller";
import JsonResponse from "csi/comm/JsonResponse";
import PostRequest from "csi/comm/PostRequest";
import { CheckboxTreeNode } from "designSystem/components/checkbox/CheckboxTree";
import { ILocaleProvider } from "designSystem/locale";
import csi from "csi/main";
import { SlimCard } from "csi/middleware/card/SlimCard";
import { SlimCardStore } from "csi/middleware/card/SlimCardStore";
import { ControllerSaveFunction } from "csi/middleware/common";
import { C8Node, cnl, ICache } from "csi/typings";
import Search from "csi/xml/Search";
import { DimDivider } from "./MassUpdateStyleSizeChartSettingsForm";
import { MassUpdateStyleSizeChartStore } from "./MassUpdateStyleSizeChartStore";

/** return a Map of Dimentions Stores */
const transformDismensionsToCheckboxTreeNodeMap = async (revisionURL: cnl, cache: ICache, locale: ILocaleProvider): Promise<Map<string, CheckboxTreeNode>> => {
	const nodeResults = await getDimensions(revisionURL);
	const rootLabel = locale.resource("Dimensions");
	const itemsMap = new Map<string, CheckboxTreeNode>();
	const items: CheckboxTreeNode[] = nodeResults.map((node) => {
		const isDivider = node.$Type !== "SizeChartDimension";
		const nodeName = locale.getNodeName(node);
		const checkBoxNode = new CheckboxTreeNode(undefined, node.$URL, nodeName, true, false);
		if (!isDivider) {
			checkBoxNode.label = SlimCard({
				displayImage: true,
				slimCardStore: new SlimCardStore(node.$URL, cache),
			});
		} else {
			checkBoxNode.label = DimDivider({
				name: nodeName,
			});
		}

		return checkBoxNode;
	});
	const rootNode = new CheckboxTreeNode(undefined, csi.EMPTY_URL, rootLabel, true);
	items.forEach((item) => { rootNode.addChild(item); });

	itemsMap.set(csi.EMPTY_URL, rootNode);
	return itemsMap;
};

/** Create and initialize MassUpdateStyleSizeChartStore */
export const createMassUpdateStyleSizeChartStore = async (
	actionController: ControllerInterface,
	onClose: () => void,
	onSave: ControllerSaveFunction,
	locale: ILocaleProvider,
): Promise<MassUpdateStyleSizeChartStore> => {
	const cache = actionController.getCache();
	let revisionURL = actionController.m_urlParent;
	const locationNode = cache.getNode(revisionURL);
	//In case teh action is executed from Shape Size Chart table row.
	if (locationNode?.$Type === "Shape") {
		revisionURL = cache.getNode(actionController.m_urlNode)?.CurrentRevision;
	}
	const itemsMap = await transformDismensionsToCheckboxTreeNodeMap(revisionURL, cache, locale);
	const store = new MassUpdateStyleSizeChartStore(cache, actionController.m_formData, onClose, onSave, locale, revisionURL, itemsMap);
	return store;
};

/** Query for all Dimensions for a given size chart revisionURL */
export async function getDimensions(revisionUrl: cnl): Promise<C8Node[]> {
	const search = new Search();
	search.setLimitPath(revisionUrl, "Child:Items");

	const response = await search.execute();
	return response.getNodes();
}

/** Mass Update Style Boms from Theme Bom placements. */
export async function massUpdateStyleSizeChart(createRevision: boolean, revisionURL: cnl, pushAllOption: boolean, dimensions: cnl[], styleSizeCharts: cnl[]): Promise<JsonResponse> {
	const request = new PostRequest("ProductSpec", "ShapeSizeChartUpdateStyleSizeCharts")
		.addParameter("CreateRevision", createRevision)
		.addParameter("ParentURL", revisionURL)
		.addParameter("Option", pushAllOption ? "Option_CreateUpdate" : "Option_Update")
		.addParameter("Dimensions", dimensions)
		.addParameter("StyleSizeCharts", styleSizeCharts)
		
		.addParameter("UpdateSizeChartProperties", true);
	return request.post();
}
